import React from "react";
import { Formik, Form, Field, FormikConfig } from "formik";

import Button from "components/commons/Button/Button";
import TextInput from "components/commons/Formik/TextInput/TextInput";
import AppStore from "stores/AppStore";

const KSEF_REGEX = /^[0-9]{10}-[0-9]{8}-[A-Za-z0-9]{12}-[A-Za-z0-9]{2}$/;

const validateMessage = (value: string) => {
    if (!KSEF_REGEX.test(value)) {
        return "Invalid format";
    }
    return undefined;
};

interface FormValues {
    message: string;
}

interface Props {
    onSubmit: FormikConfig<FormValues>["onSubmit"];
}

const SubmitKsefForm: React.FC<Props> = ({ onSubmit }) => {
    const {
        i18n: {
            invoicePreview: { submitKsefNumber }
        }
    } = AppStore;

    return (
        <Formik
            initialValues={{ message: "" }}
            onSubmit={onSubmit}
        >
            {({ handleSubmit, isSubmitting }) => (
                <Form className="c-invoice-summary__form-inner">
                    <div className="c-invoice-summary__form-row">
                        <Field name="message" label={submitKsefNumber} component={TextInput} validate={validateMessage} />
                        <Button
                            text={isSubmitting ? "Submitting..." : "Submit"}
                            disabled={isSubmitting}
                            onClick={handleSubmit}
                            className="c-invoice-summary__button"
                        />
                    </div>
                </Form>
            )}
        </Formik>
    );
};

export default SubmitKsefForm;
